/**
 * Aba Apetite proativo em edição (PR4). Edita `proactiveAppetite`
 * (none|conservative|balanced|active — únicos do backend). Tipos de
 * oportunidade/carência do mockup seguem fora (sem fonte no serializer).
 */

import { APPETITE_LABELS } from '../playbook-labels';

import type { PlaybookProactiveAppetite } from '../types';
import type { PlaybookForm } from '../use-playbook-form';

const APPETITE_ORDER: PlaybookProactiveAppetite[] = ['none', 'conservative', 'balanced', 'active'];

export function TabAppetiteEdit({ form }: { form: PlaybookForm }): JSX.Element {
  const { draft, set } = form;

  return (
    <div className="pb-panel" role="tabpanel" aria-label="Apetite">
      <h2 className="pb-panel__title">Apetite proativo</h2>

      <div className="pb-panel__section">
        <span className="pb-panel__section-label">Nível de proatividade deste playbook</span>
        <div className="pb-radio-row" role="radiogroup" aria-label="Nível de proatividade">
          {APPETITE_ORDER.map((level) => {
            const meta = APPETITE_LABELS[level];
            const selected = level === draft.proactiveAppetite;
            return (
              <button
                key={level}
                type="button"
                role="radio"
                aria-checked={selected}
                className={'pb-radio pb-radio--editable' + (selected ? ' pb-radio--selected' : '')}
                onClick={() => {
                  set('proactiveAppetite', level);
                }}
              >
                <span className="pb-radio__dot" />
                <span className="pb-radio__main">
                  <span className="pb-radio__label">{meta.label}</span>
                  <span className="pb-radio__desc">{meta.desc}</span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
